import { useEffect } from "react";

const useOutsideClick = (ref: any, callback: any) => {
  const handleClick = (e: Event) => {
    try {
      const target = e.target as Element;
      if (
        ref.current &&
        !ref.current.contains(target) &&
        !target.className.includes("dont-exit")
      ) {
        // if (target.className.includes("tutorial")) return;
        callback();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
};

export default useOutsideClick;
